import { HeadingProps } from "../../Types/CommonElementType";

const H3:React.FC<HeadingProps> = (props) => {
  const { children = "" } = props;
  return (
    <h3 {...props} style={props.style}>
      {children}
    </h3>
  );
};

export default H3;
